import { Component, input } from '@angular/core';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { CrewMember } from '../shows.model';

/**
 * Who took part, under the heading "Credits" — the crew of the show and of the episode or clip.
 * The code says "crew" because the platform already uses "credits" for images and deliveries.
 * A member is named; a non-member is named
 * and linked where an editor gave a link.
 */
@Component({
  selector: 'multisite-shows-credits',
  imports: [TranslocoModule],
  providers: [provideTranslocoScope('shows')],
  template: `
    @if (crew().length) {
      <ng-container *transloco="let t">
        <p class="h5">{{ t('shows.credits') }}</p>
        <dl class="mb-0">
          @for (member of crew(); track member.id) {
            <dt class="font-weight-normal text-muted small">{{ t('shows.role.' + member.role) }}</dt>
            <dd>
              @if (member.url) {
                <a [href]="member.url" target="_blank" rel="noopener">{{ member.name }}</a>
              } @else {
                {{ member.name }}
              }
            </dd>
          }
        </dl>
      </ng-container>
    }
  `,
})
export class ShowsCreditsComponent {
  crew = input.required<CrewMember[]>();
}
